export default __webpack_public_path__ + "static/media/Img0040.63dd1fe4.jpg";